import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=04296546&"
import script from "./confirmOrder.vue?vue&type=script&lang=js&"
export * from "./confirmOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports